import { Injectable } from '@angular/core';
import { NgbTimepickerI18n } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class AtaraxiaTimepickerI18n extends NgbTimepickerI18n {
  public getMorningPeriod() {
    return $localize`:TimePicker|Time picker morning period label@@timePickerMorningPeriodLabel:AM`;
  }

  public getAfternoonPeriod(): string {
    return $localize`:TimePicker|Time picker afternoon period label@@timePickerAfternoonPeriodLabel:PM`;
  }
}
